<template>
  <div class="show-box">
    <div class="swiper-container show-poll-swiper show-id-swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(v,ind) in tablesName">
          <ul class="show-list">
            <li class="broadcast" v-for="(val,i) in twoNumbers"
                :attr-item="JSON.stringify({url: tables[ind*2+i].url,id: tables[ind*2+i].id,img_path: tables[ind*2+i].img_path,type:  tables[ind*2+i].type})"
                attr-type="tablesName">
              <a href="javascript:void(0);">
                <div class="show-remd-logo" v-if="tables[ind*2+i].hostunit">
                  <img :src="tables[ind*2+i].hostunit.host_avatar" alt=""/>
                </div>
                <div class="show-remd-tit" v-if="tables[ind*2+i].hostunit">
                  {{tables[ind*2+i].hostunit.channel_name}}
                </div>

                <div class="pic-box" v-if="tables[ind*2+i].playbill">
                  <img :src="(tables[ind*2+i].playbill.playbill_small || tables[ind*2+i].playbill.playbill)+'?p=3&o=2&w=350&h=197'" alt=""/>
                  <!--  <i class="icon-time">01.02</i>-->
                </div>
                <p>{{tables[ind*2+i].title}}</p>

              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'tables',
      'tablesName'
    ],
    data() {
      return {
        twoNumbers: 2
      }
    },
    methods: {
      //操作按钮事件
    },
    mounted: function () {
      //操作DOM
    }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/template/newestTpl.vue